<template>
<div id="studentview" class="okr">
  <el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ path: '/okr' }">Students</el-breadcrumb-item>
  <el-breadcrumb-item>{{student.tbl_student.firstname}} {{student.tbl_student.surname}}</el-breadcrumb-item>
</el-breadcrumb>
<br>
  <el-button type="primary" @click=backClick(tbl_conf_class.testgroup) size="small">
    <icon name="chevron-left"></icon>
  </el-button>
  <el-button type="primary" v-loading.fullscreen="loading" element-loading-text="Bezig met laden OKR ..." size="small">
    <icon name="floppy-o"></icon>
  </el-button>
  <br /><br />
  <el-form ref="student_form" :model="student" label-width="142px" label-position="left" readonly>
    <el-row :gutter="10">
      <el-col :lg="8" :sm="8" :md="8" :xs="8">
        <el-card class="box-card">
          <span class="okrhead">Personalia</span>
          <br/>
          <br>
          Test: {{student.tbl_student.surname}}
          <el-form-item class="okritem" label="Schoolnr :">
            <el-input size="small" v-model="tbl_school.schoolnumber" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Testgroup :">
            <el-input size="small" v-model="tbl_conf_class.testgroup" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Leerlingnr :">
            <el-input size="small" v-model="student.student_number" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Groep :">
            <el-input size="small" v-model="tbl_conf_class.tbl_grade.grade" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Achternaam :">
            <el-input size="small" v-model="tbl_student.surname" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Voorvoegsel :">
            <el-input size="small" v-model="tbl_student.preposition" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Voornaam :">
            <el-input size="small" v-model="tbl_student.firstname" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="IDNR :">
            <el-input size="small" v-model="tbl_student.governement_id" @blur="updatePersonalia()" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Geboortedatum :">
            <el-date-picker type="date" placeholder="Geboorte datum.." v-model="tbl_student.birthdate" @blur="updatePersonalia()" readonly></el-date-picker>
          </el-form-item>
          <el-form-item class="okritem" label="Geboorteplaats :">
            <el-select size="small" v-model="tbl_student.birthplace_id" filterable placeholder="Kies een geboorteplaats ..." @change="updatePersonalia()">
              <el-option v-for="item in birthplaces" :label="item.name" :value="item.id" :key="item.id" readonly>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem" label="Sexe :">
            <el-select size="small" v-model="tbl_student.gender_id" filterable placeholder="Kies een geslacht ..." @change="updatePersonalia()">
              <el-option v-for="item in genders" :label="item.name" :value="item.id":key="item.id" readonly>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem" label="Moedertaal :">
            <el-select size="small" v-model="tbl_student.native_language_id" filterable placeholder="Kies een moedertaal ..." @change="updatePersonalia()">
              <el-option v-for="item in languages" :label="item.name" :value="item.id" :key="item.id" readonly>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem" label="Adres :">
            <el-input size="small" v-model="tbl_student.address" @blur="updatePersonalia()" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Woonbuurt :">
            <el-input size="small" v-model="tbl_student.neighborhood" @blur="updatePersonalia()" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Telefoon :">
            <el-input size="small" v-model="tbl_student.telephone" @blur="updatePersonalia()" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Email :">
            <el-input size="small" v-model="tbl_student.email" @blur="updatePersonalia()" readonly></el-input>
          </el-form-item>
          <el-form-item class="okritem" label="Godsdienst :">
            <el-select size="small" v-model="tbl_student.denomination_id" filterable placeholder="Godsdienst ..." @change="updatePersonalia()">
              <el-option v-for="item in religions" :label="item.name" :value="item.id" :key="item.id" readonly>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem" label="Nationaliteit :">
            <el-select size="small" v-model="tbl_student.nationality_id" filterable placeholder="Nationaliteit ..." @change="updatePersonalia()">
              <el-option v-for="item in nationality" :label="item.name" :value="item.id" :key="item.id" readonly>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem" label="Ingescherven vanaf:">
            <el-date-picker size="small" type="date" placeholder="" v-model="student.registration_date" @blur="updatePersonalia()" readonly></el-date-picker>
          </el-form-item>
          <el-form-item class="okritem" label="Afkomstig van :">
            <!-- <el-input size="small" v-model="tbl_student.last_school" @blur="updatePersonalia()"></el-input> -->
            <el-select size="small" v-model="student.last_school" filterable placeholder="Kies vorige school ..." @change="updatePersonalia()">
              <el-option v-for="item in schools" :label="item.name" :value="item.id" :key="item.id" readonly>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem" label="Leerstoornis:">
            <el-checkbox-group v-model="disabilities_selected" @change="update_learning_disorder()">
              <el-checkbox v-for="item in disabilities" :label="item.id" :key="item.id" readonly>{{item.learning_disability}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="okritem" label="Slechtziend:">
            <el-checkbox v-model="tbl_student.visually_impaired" @change="updatePersonalia()" readonly></el-checkbox>
          </el-form-item>
          <el-form-item class="okritem " label="In welke taal maakt leerling rekenen? ">
            <el-select size="small " v-model="student.language_id " filterable placeholder="Kies taal ... " @change="updatePersonalia() ">
              <el-option v-for="item in mathlanguages " :label="item.language" :key="item.id" :value="item.id " readonly>
              </el-option>
            </el-select>
          </el-form-item>
        </el-card>
      </el-col>
      <el-col :lg="16 " :sm="16 " :md="16 " :xs="16 ">
        <el-row :gutter="10 ">
          <el-col :lg="12 " :sm="12 " :md="12 " :xs="12 ">
            <verzuimtelaat :studentid="student.student_id "></verzuimtelaat>
          </el-col>
          <el-col :lg="12 " :sm="12 " :md="12 " :xs="12 ">
            <interesse :studentid="student.student_id "></interesse>
          </el-col>
        </el-row>
        <el-row :gutter="10 ">
          <el-col :lg="12 " :sm="12 " :md="12 " :xs="12 ">
            <andere :studentid="student.student_id "></andere>
          </el-col>
          <el-col :lg="12 " :sm="12 " :md="12 " :xs="12 ">
            <gedrag :studentid="student.student_id "></gedrag>
          </el-col>
        </el-row>
        <el-row :gutter="10 ">
          <el-col :lg="24 " :sm="24 " :md="24 " :xs="24 ">
            <leerprestaties :studentid="student.student_id "></leerprestaties> </el-col>
        </el-row>
        </el-col>
    </el-row>
    <el-row :gutter="10 ">
      <el-col :lg="8 " :sm="8 " :md="8 " :xs="8 ">
        <sociaalemo :studentid="student.student_id "></sociaalemo>
      </el-col>
      <el-col :lg="8 " :sm="8 " :md="8 " :xs="8 ">
        <omgangleerkracht :studentid="student.student_id "></omgangleerkracht>
      </el-col>
      <el-col :lg="8 " :sm="8 " :md="8 " :xs="8 ">
        <contactouders :studentid="student.student_id "></contactouders>
      </el-col>
    </el-row>
    <el-row :gutter="10 ">
      <el-col :lg="24 " :sm="24 " :md="24 " :xs="24 ">
        <leerdeficientie :studentid="student.student_id "></leerdeficientie>
      </el-col>
    </el-row>
    <el-row :gutter="10 ">
      <el-col :lg="14 " :sm="14 " :md="14 " :xs="14 ">
        <subjectmarks :studentid="student.student_id "></subjectmarks>
      </el-col>
      <el-col :lg="10 " :sm="10 " :md="10 " :xs="10 ">
        <el-card class="box-card ">
          <span class="okrhead ">Werkhouding</span>
          <h4>Concentratie</h4>
          <concentratie :studentid="student.student_id "></concentratie>
          <h4>Motivatie</h4>
          <motivatie :studentid="student.student_id "></motivatie>
          <h4>Werktempo</h4>
          <werktempo :studentid="student.student_id "></werktempo>
          <h4>Doorzettingsvermogen</h4>
          <doorzettingsvermogen :studentid="student.student_id "></doorzettingsvermogen>
          <h4>Nauwkeurigheid</h4>
          <nauwkeurigheid :studentid="student.student_id "></nauwkeurigheid>
          <h4>Zelfstandigheid</h4>
          <zelfstandigheid :studentid="student.student_id "></zelfstandigheid>
          <h4>Voorkeur vervolgonderwijs</h4>
            <el-form-item class="okritem" label="Advies directeur vervolgonderwijs:" label-width="350px">
            <el-select v-model="further_education.director_advice" filterable placeholder="Select" @change="update_vervolgonderwijs()">
              <el-option label="HAVO" value="HAVO"> </el-option>
              <el-option label="VSBO" value="VSBO"> </el-option>
              <el-option label="AGO" value="AGO"> </el-option>
            </el-select>
          </el-form-item>
          <el-form ref="voorkeur" label-position="top">
            <el-form-item class="okritem" label="Motivering van advies door directeur" label-width="350px">
              <el-input type="textarea" size="small" style="width:400px;" v-model="further_education.justification" @blur="update_vervolgonderwijs()"></el-input>
            </el-form-item>
          </el-form>
          </el-form-item>
          <h4>Schoolkeuze vervolgonderwijs</h4>
          <el-form-item class="okritem " label="Schoolkeuze Havo 1 : " label-width="175px ">
            <el-select style="width:300px; " size="small " v-model="further_education.sys_havo_id_1 " filterable @change="update_vervolgonderwijs() ">
              <el-option v-for="item in havo " :label="item.name " :value="item.id " :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem " label="Schoolkeuze Havo 2 : " label-width="175px ">
            <el-select style="width:300px; " size="small " v-model="further_education.sys_havo_id_2 " filterable @change="update_vervolgonderwijs() ">
              <el-option v-for="item in havo " :label="item.name " :value="item.id" :key="item.id" >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem " label="Schoolkeuze Havo 3 : " label-width="175px ">
            <el-select style="width:300px; " size="small " v-model="further_education.sys_havo_id_3 " filterable @change="update_vervolgonderwijs() ">
              <el-option v-for="item in havo " :label="item.name " :value="item.id " :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem " label="Schoolkeuze VSBO 1 : " label-width="175px ">
            <el-select style="width:300px; " size="small " v-model="further_education.sys_vsbo_id_1 " filterable @change="update_vervolgonderwijs() ">
              <el-option v-for=" item in vsbo " :label="item.name " :value="item.id " :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem " label="Schoolkeuze VSBO 2 : " label-width="175px ">
            <el-select style="width:300px; " size="small " v-model="further_education.sys_vsbo_id_2 " filterable @change="update_vervolgonderwijs() ">
              <el-option v-for="item in vsbo " :label="item.name " :value="item.id " :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="okritem " label="Schoolkeuze VSBO 3 : " label-width="175px ">
            <el-select style="width:300px; " size="small " v-model="further_education.sys_vsbo_id_3 " filterable @change="update_vervolgonderwijs() ">
              <el-option v-for="item in vsbo " :label="item.name " :value="item.id " :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10 ">
      <el-col :lg="24 " :sm="24 " :md="24 " :xs="24 ">
        <!-- <ouders :studentid="student.student_id "></ouders> -->
        <el-card class="box-card " id="ouders ">
          <div slot="header ">
            <span class="okrhead ">Ouders</span>
          </div>
          <el-form-item class="okritem " label="Ouders waren niet tevreden met advies en hebben gesprek aangevraagd " label-width="500px ">
            <el-checkbox v-model="further_education.objection_advice " @change="update_vervolgonderwijs() "> </el-checkbox>
          </el-form-item>
          <el-form-item class="okritem " label="Ouders gaan in beroep tegen de uitslag" label-width="500px ">
            <el-checkbox v-model="further_education.appeal_result " @change="update_vervolgonderwijs() "> </el-checkbox>
          </el-form-item>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="10 ">
      <el-col :lg="24 " :sm="24 " :md="24 " :xs="24 ">
        <el-card class="box-card ">
          <span class="okrhead ">Bijzonderheden</span>
          <el-input type="textarea" :rows="5" placeholder="Please input" v-model="further_education.particularies" @blur="update_vervolgonderwijs">
          </el-input>
          <br />
        </el-card>
      </el-col>
    </el-row>
  </el-form>
</div>
</template>

<script>
import Axios from 'axios'
import moment from 'moment'
//import Icon from 'vue-awesome/components/Icon.vue'
import Markitems from '../components/Markitems'
import VerzuimTelaat from '../components/okr/VerzuimTelaat'
import Interesse from '../components/okr/Interesse'
import Andere from '../components/okr/Andere'
import Gedrag from '../components/okr/Gedrag'
import Leerprestaties from '../components/okr/Leerprestaties'
import Sociaalemo from '../components/okr/Sociaalemo'
import Omgangleerkracht from '../components/okr/Omgangleerkracht'
import Contactouders from '../components/okr/Contactouders'
import Leerdeficientie from '../components/okr/Leerdeficientie'
import Concentratie from '../components/okr/Concentratie'
import Motivatie from '../components/okr/Motivatie'
import Werktempo from '../components/okr/Werktempo'
import Doorzettingsvermogen from '../components/okr/Doorzettingsvermogen'
import Zelfstandigheid from '../components/okr/Zelfstandigheid'
import Nauwkeurigheid from '../components/okr/Nauwkeurigheid'
// import Vervolgonderwijs from '../components/okr/Vervolgonderwijs'
// import Ouders from '../components/okr/Ouders'
import Subjectmarks from '../components/okr/Subjectmarks'


import {
  API_ROOT
} from '../config'



var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000,
  withCredentials: true


});


export default {
  name: 'studentview',
  components: {
    
    Markitems,
    VerzuimTelaat,
    Interesse,
    Andere,
    Gedrag,
    Leerprestaties,
    Sociaalemo,
    Omgangleerkracht,
    Contactouders,
    Leerdeficientie,
    Concentratie,
    Motivatie,
    Werktempo,
    Doorzettingsvermogen,
    Nauwkeurigheid,
    // Vervolgonderwijs,
    Zelfstandigheid,
    // Ouders,
    Subjectmarks
  },
  data: function() {
    return {
      //main_loading: true,
      birthplaces: [],
      genders: [],
      languages: [],
      mathlanguages: [],
      religions: [],
      schools: [],
      nationality: [],
      disabilities: [{
        id: '',
        learning_disability: ''
      }],
      disabilities_selected: ['', '', '', '', '', '', ''],
      further_education: {
        id: '',
        student_id: '',
        director_advice: '',
        justification: '',
        sys_havo_id_1: '',
        sys_havo_id_2: '',
        sys_havo_id_3: '',
        sys_vsbo_id_1: '',
        sys_vsbo_id_2: '',
        sys_vsbo_id_3: '',
        objection_advice: '',
        appeal_result: '',
        particularies: ''
      },
      havo: [],
      havo1_selected: [],
      havo2_selected: [],
      havo3_selected: [],
      vsbo: [],
      vsbo1_selected: [],
      vsbo2_selected: [],
      vsbo3_selected: [],
      bijzonderheden: '',
      marksData: [],
      student: {
        id: '',
        schoolyear_id: '',
        school_id: '',
        class_id: '',
        tbl_conf_class: {
          id: "",
          school_id: "",
          grade_id: "",
          tbl_grade: {
            id: "",
            grade: "",
            description: ""
          },
          name: "",
          testgroup: ""
        },
        student_id: '',
        language_id: '',
        student_number: '',
        registration_date: '',
        last_school: '',
        tbl_student: {
          id: '',
          governement_id: '',
          surname: '',
          firstname: '',
          preposition: '',
          nickname: '',
          gender_id: '',
          birthdate: '',
          birthplace_id: '',
          denomination_id: '',
          native_language_id: '',
          address: '',
          neighborhood: '',
          telephone: '',
          nationality_id: '',
          telephone_owner: '',
          email: '',
          visually_impaired: false

        },
        tbl_school: {
          id: '0',
          schoolboard_id: '',
          name: ' ',
          address: '',
          telephone: '',
          fax: '',
          email: '',
          webpage: '',
          d_name: '',
          d_address: '',
          d_telephone: '',
          d_fax: '',
          d_email: '',
          w_name: '',
          w_address: '',
          w_telehpone: '',
          w_fax: '',
          w_email: '',
          schoolnumber: '',
          schooltype_id: '',
          createdAt: '',
          updatedAt: ''
        }

      }
    }
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    //this.fetch()
    console.log('Fetching Data')

    this.fetch_data();
    this.fetch_student();
    this.fetch_marks();


    console.log('Student Form');
    console.log(this.student_form);
  },
  computed: {
    loading() {

      var load_object = this.$store.getters.getLoading;
      var keys = _.keys(load_object);
      var load = true;

      console.log('Watch');
      console.log(keys);
      for (var i = 0; i < keys.length; i++) {
        console.log(load_object[keys[i]]);
        if (load_object[keys[i]]) {
          i = keys.length;
        } else {
          load = false;
        }
      }

      return load;
    },
    user() {
      return this.$store.getters.getUser;
    },
    firstlogin() {
      return this.$store.getters.getFirstlogin;
    },
    tbl_student() {
      if (!_.isUndefined(this.student)) {

        return this.student.tbl_student
      } else {
        return {
          id: '',
          governement_id: '',
          surname: '',
          firstname: '',
          preposition: '',
          nickname: '',
          gender_id: '',
          birthdate: '',
          birthplace_id: '',
          denomination_id: '',
          native_language_id: '',
          address: '',
          neighborhood: '',
          telephone: '',
          nationality_id: '',
          telephone_owner: '',
          email: '',
          visually_impaired: ''
        }

      }
    },
    tbl_conf_class() {
      if (!_.isUndefined(this.student)) {
        return this.student.tbl_conf_class
      } else {
        return {
          id: "",
          school_id: "",
          grade_id: "",
          tbl_grade: {
            id: "",
            grade: "",
            description: ""
          },
          name: "",
          testgroup: ""
        }

      }
    },
    tbl_school() {
      if (!_.isUndefined(this.student)) {
        return this.student.tbl_school
      } else {
        return {
          id: '0',
          schoolboard_id: '',
          name: ' ',
          address: '',
          telephone: '',
          fax: '',
          email: '',
          webpage: '',
          d_name: '',
          d_address: '',
          d_telephone: '',
          d_fax: '',
          d_email: '',
          w_name: '',
          w_address: '',
          w_telehpone: '',
          w_fax: '',
          w_email: '',
          schoolnumber: '',
          schooltype_id: '',
          createdAt: '',
          updatedAt: ''
        }

      }
    }
  },
  methods: {
    fetch_student() {
      var self = this
      instance.get('/student-class/' + this.$route.params.id).then(function(response) {
        var stud = response.data.data;
        _.merge(self.student, response.data.data);
        console.log(self.student);
        self.tbl_student.visually_impaired = (self.student.tbl_student.visually_impaired == 1 ? true : false)
      });
    },
    updatePersonalia() {
      instance.post('/student/update', this.tbl_student).then(function(response) {
        //console.log(response.data.data);
      });
      instance.post('/student-class/update', this.student).then(function(response) {
        //console.log(response.data.data);
      });
    },
    update_vervolgonderwijs() {
      //first delete all disabilities the nsave new list
      console.log('UPDATE VERVOLGONDERWIJS!!!!!!');
      console.log(this.further_education);

      this.further_education.student_id = this.student.student_id;
      instance.post('/further-education-update', this.further_education).then(function(response) {
        //console.log(response.data.data);


      });


    },
    update_marks(obj) {
      //first delete all disabilities the nsave new list
      console.log('Update marks');
      console.log(obj);



      instance.post('/student-misc-mark/update', {
        student_id: obj.id,
        sys_miscellaneous_id: obj.sys_miscellaneous_id,
        mark: obj.mark
      }).then(function(response) {
        //console.log(response.data.data);
      });


    },

    update_learning_disorder() {
      //first delete all disabilities the nsave new list

      instance.post('/student-learning-disability/delete/', {
        id: this.student.student_id
      }).then(function(response) {
        //console.log(response.data.data);
      });

      console.log('UPDATETING LEARNING DISABILITIES!!!!');

      for (var i = 0; i < this.disabilities_selected.length; i++) {
        if (this.disabilities_selected[i] > 0) {
          instance.post('/student-learning-disability', {
            learning_disability_id: this.disabilities_selected[i],
            student_id: this.student.student_id
          }).then(function(response) {
            //console.log(response.data.data);
          });
        }

      }

    },
    fetch() {

      for (var i = 1; i < 18; i++) {
        this.$store.dispatch('marks', i);
      }


    },
    fetch_marks() {
      this.params = this.$route.params;

      var self = this;


      instance.get('/further-education/' + this.params.id).then(function(response) {

        if (response.data.data.length > 0) {

          console.log('Further Education')
          console.log(response.data.data[0]);


          _.merge(self.further_education, response.data.data[0]);
          self.further_education.objection_advice = (self.further_education.objection_advice == 1 ? true : false);
          self.further_education.appeal_result = (self.further_education.appeal_result == 1 ? true : false);

        }

      });

      console.log('AFTER LOADING LEARNING DISABILITY!!!!!!!!!!!!');
      console.log(this.params.id);
      instance.get('/student-learning-disability-student/' + this.stundent.student_id).then(function(response) {
        var selected = [];
        console.log('Fetch mongool');
        console.log(self.params.id);
        console.log(response.data.msg);
        console.log(response.data.data);
        for (var i = 0; i < response.data.data.length; i++) {

          self.$set(self.disabilities_selected, i, response.data.data[i].learning_disability_id);
        }


        self.$store.dispatch('load', {
          name: 'vervolgonderwijs',
          value: false
        });


      });


      // instance.get('/subjects').then(function(response) {
      //
      //   var subjects = response.data.data;
      //   _.merge(self.marksData, response.data.data);
      //   self.loading = false;
      //
      // });
    },
    fetch_data() {


      this.params = this.$route.params;
      //console.log(this.params);

      var self = this;
      //TODO:move lists to store later

      instance.get('/birthplace').then(function(response) {
        _.merge(self.birthplaces, response.data.data);

      });

      instance.get('/native-langauge').then(function(response) {
        _.merge(self.languages, response.data.data);
      });

      instance.get('/math-language').then(function(response) {
        _.merge(self.mathlanguages, response.data.data);
      });

      instance.get('/denomination').then(function(response) {
        _.merge(self.religions, response.data.data);
      });

      instance.get('/school').then(function(response) {
        _.merge(self.schools, response.data.data);
      });

      instance.get('/gender').then(function(response) {
        _.merge(self.genders, response.data.data);
      });

      instance.get('/nationality').then(function(response) {
        _.merge(self.nationality, response.data.data);
      });


      instance.get('/school/type/4').then(function(response) {
        _.merge(self.havo, response.data.data);
      });

      instance.get('/school/type/3').then(function(response) {
        _.merge(self.vsbo, response.data.data);
      });

      instance.get('/learning-disability/').then(function(response) {
        _.merge(self.disabilities, response.data.data);

      });




    },
    format(date, format) {
      if (!date) {
        return 'N/A'
      }
      return moment(date).format(format);
    },
    backClick(testgroup) {

      console.log(testgroup);

      this.$router.push({
        path: '/okr',
        params: {
          testgrp: testgroup
        }
      })

    }
  }
}
</script>
<style scoped>
.fieldheader {
  display: inline;
  font-size: 1.1em;
  font-weight: 500;
  margin: 0;
  margin-right: .5em;
}

.field {
  line-height: 30px;
  padding-bottom: 10px;
}

.okr {
  /*font-family: "Times New Roman";
  line-height: 25px;
  border-style: solid;
  border-width: thin;*/
  padding-top: 2px;
  padding-left: 10px;
}

.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.okrhead {
  font-size: 20px;
  font-weight: bold;
}

.okritem {
  margin-bottom: 5px;
}
</style>
